import { type ChangeEvent } from 'react'

import styled from 'styled-components'

import {
    IconMagnifyingGlass,
    IconSortAsc,
    IconSortDesc
} from 'assets/svg/sprite'
import { InputText } from 'components-ref/atoms/inputs/text/InputText'
import { useViewLikesContext } from 'helpers/hooks/useViewLikesContext/useViewLikesContext'
import colors from 'styles/colors'
import { SortDirection } from 'types/enums'
import { BorderVariant } from 'types/enums/style/input/border-variant/border-variant'

export const ViewLikesSearchUsers = () => {
    const {
        state: { searchTerm, sortDirection, changeSortDirection, setSearchTerm }
    } = useViewLikesContext()

    const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
        const text = event.currentTarget.value
        setSearchTerm(text)
    }

    const changeDirection = () => {
        changeSortDirection(sortDirection)
    }

    return (
        <StyledContainer>
            <InputWrapper>
                <InputText
                    id='search-users'
                    value={searchTerm}
                    onChange={handleOnChange}
                    hasBorder={true}
                    borderVariant={BorderVariant.DARK}
                    placeholder='Search users'
                    icon={<IconMagnifyingGlass width='20' height='20' />}
                />
            </InputWrapper>
            <SortButton onClick={changeDirection}>
                {sortDirection === SortDirection.ASCENDING ? (
                    <IconSortAsc />
                ) : (
                    <IconSortDesc />
                )}
            </SortButton>
        </StyledContainer>
    )
}

const InputWrapper = styled.div`
    flex: 1;
    width: 100%;
`

const StyledContainer = styled.div`
    margin-top: 20px;
    display: flex;
`

const SortButton = styled.button`
    margin-left: 10px;
    width: 5rem;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${colors.slateBlue};
    outline: none;
    border: none;
    border-radius: 1rem;
`
